import { OrganizationsSliceActions } from "./workspace.store";

export const {
  setOrganization,
  patchOrganization,
} = OrganizationsSliceActions;
